var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content content--no-first-letter"},[_c('multimedia-content'),_vm._v(" "),_c('input-area'),_vm._v(" "),_c('source-code',{domProps:{"innerHTML":_vm._s(_vm.postfixTranslation)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }